import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export const AppHeader = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 border-b border-ely-border/50 bg-ely-surface/70 backdrop-blur-xl">
      <div className="mx-auto flex max-w-5xl items-center justify-between px-6 py-4 md:px-10">
        <Link to="/app" className="flex items-center gap-2" data-testid="app-logo">
          <span className="font-serif text-2xl text-ely-text">Soul-Key</span>
          <span className="mt-1 h-1.5 w-1.5 rounded-full bg-ely-primary" />
        </Link>
        <nav className="flex items-center gap-6 font-sans text-sm text-ely-muted">
          <Link to="/app" className="transition-colors hover:text-ely-text" data-testid="nav-soulkeys">
            Your Soul-Keys
          </Link>
          {user && user.role === "admin" && (
            <Link to="/admin" className="transition-colors hover:text-ely-primary" data-testid="nav-admin">
              Admin
            </Link>
          )}
          {user && (
            <button
              onClick={() => { logout(); navigate("/login"); }}
              data-testid="nav-logout"
              className="transition-colors hover:text-ely-primary"
            >
              Log out
            </button>
          )}
        </nav>
      </div>
    </header>
  );
};
